/// <reference path="ScheduleVaccineLanding.js" />
import React from "react";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import * as d from "../../reducers/domainReducer";
import Spinner from "../common/spinner";
import VaccineEligibilitySurvey from "./VaccineEligibilitySurvey";
import SelectPatient from '../common/SelectPatient';

class VaccineEligibility extends React.Component {
    constructor(props) {
        super(props);
        this.state = { userSelected: false };
    }

    onUserSwitched = (userSelected, index) => {
        //window.userToSwitch = userSelected;
        this.setState({ userSelected });
        this.props.switchToMyChartUser(userSelected, index);

    }

    //checkCovidVaccineEligibility = () => {
    //    var { isCovidVaxScheduleEligible, proxyCurrentUser, isProxyAvailable, switchingProxyUser } = this.props;
    //    if (((this.state.userSelected && !isProxyAvailable) || (this.state.userSelected && isProxyAvailable)) && !switchingProxyUser && isCovidVaxScheduleEligible) {
    //        this.goToScheduleVaccine(proxyCurrentUser);
    //    }
    //}

    //onScheduleAppointmentClick = () => {
    //    console.log("navigate to find care vaccine search");
    //    this.props.history.push({
    //        pathname: '/findcare/vaccine'
    //    });
    //}

    //goToScheduleVaccine = (proxyCurrentUser) => {
    //    //debugger;
    //    var suffixPath = "/schedule_covid_vaccine";
    //    var searchParams = '?xid=' + proxyCurrentUser.externalId;
    //    //   var newUrl = window.location.origin + suffixPath;
    //    this.props.history.push({ pathname: "/schedule_covid_vaccine", search: searchParams });
    //}

    updateAge = (value) => {
        this.setState({ age: value }, this.checkAge);
    };

    componentDidMount() {
       // this.checkCovidVaccineEligibility();
    }

    componentDidUpdate() {
        //this.checkCovidVaccineEligibility();
    }


    render() {
        const {
            hasMyChart, age, myProxies, isProxyUser, currentUser, serverData, switchingProxyUser, isProxyAvailable, proxyListFailure, proxyListLoaded, technicalHelpDeskNumber, technicalHelpDeskHours, isCovidVaxScheduleEligible
        } = this.props;
        const userAge = isProxyUser ? currentUser && currentUser.ageYears : age;

        const noSurveyMessage = (
            <React.Fragment>
                <div className="container-fluid body-content check-vaccine-eligibility" >
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            <h1 className="page-heading">COVID-19 Vaccine Eligibility</h1>
                            <p>To check eligibility, link your BSWH medical record by contacting the MyBSWHealth technical help desk {technicalHelpDeskHours} at <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.</p>
                        </div>
                    </div>
                </div >
            </React.Fragment >);


        return (
            <React.Fragment>
                {(!proxyListFailure && !proxyListLoaded || switchingProxyUser) && <Spinner />}
                {!this.state.userSelected && isProxyAvailable &&
                    <div className="container-fluid body-content check-vaccine-eligibility">
                        <div className="row">
                            <div className="col-12 maxWidth-content">
                                <SelectPatient
                                    steptitle="Select Patient"
                                    myProxies={myProxies}
                                    hasMychart={hasMyChart}
                                    currentUser={currentUser}
                                    switchToMyChartUser={this.onUserSwitched}
                                    isAdult={userAge && userAge > 17}
                                    userSelected={this.state.userSelected}
                                    onUserSelected={userSelected => this.setState({ userSelected })}
                                    shouldHideContinueButton
                                    activityCode="MBHWeb.UI.Covid19VaccineEligibilitySurvey.AddDependent.Clicked"
                                    message={"Who is this for?"}
                                    iconLeftClass={"svg-schedule-color"}
                                    serverData={serverData} />
                            </div>
                        </div>
                    </div>}
                {
                    hasMyChart && ((this.state.userSelected && !switchingProxyUser) || (!this.state.userSelected && !isProxyAvailable)) && <VaccineEligibilitySurvey />
                }
                {
                    !hasMyChart && noSurveyMessage
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const pl = [];
    if (state.domain.pl) {
        state.domain.pl.forEach((proxy) => {
            pl.push(d.hydrateProxyUser(proxy));
        });
    }

    return {
        hasMyChart: state.domain.hm,
        age: state.domain.age,
        myProxies: pl,
        isCovidVaxScheduleEligible: state.memberships.hasAuthorizedFeatureSchedCovidVax,
        isProxyUser: state.domain.ip,
        currentUser: d.hydrateProxyUser(state.domain.cu),
        proxyCurrentUser: state.memberships.currentUser,
        switchingProxyUser: state.memberships.switchingProxyUser,
        serverData: state.session.serverData,
        proxyListFailure: state.memberships.proxyListFailure,
        proxyListLoaded: state.memberships.proxyListLoaded,
        isProxyAvailable: state.domain.hm && pl && pl.length > 1 ? true : false,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours:""
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        switchToMyChartUser: (user, index) => {
            dispatch({ type: types.SWITCH_USER_SAGA, user, index });
            dispatch({ type: types.SWITCH_TO_PHARMACY_USER, pharmacyUser: null });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VaccineEligibility);